export const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export const isObject = (object) => {
	return object != null && typeof object === 'object';
}

export const runFunction = (func, arg) => {
    const args = toArray(arg);
    if (typeof func === 'function') {
        args ? func(...args) : func();
    }
};

export const toArray = (a) => (a ? (Array.isArray(a) ? a : [a]) : []);

export const buffer2hexArr = (data) => {
    const result = [];

    for (let i = 0; i < data.length; i += 2) {
        result.push(parseInt(data.substr(i, 2), 16));
    }
    return result;
};

export const isAlphaNumeric = (str) => {
    let code, i, len;

    for (i = 0, len = str.length; i < len; i++) {
        code = str.charCodeAt(i);
        if (
            !(code > 47 && code < 58) && // numeric (0-9)
            !(code > 64 && code < 91) && // upper alpha (A-Z)
            !(code > 96 && code < 123)
        ) {
            // lower alpha (a-z)
            return false;
        }
    }
    return true;
};

export const decToBin = (dec) => {
    let bin = dec.toString(2);
    return bin.padStart(8, '0');
}

export const binToDec = (bin) => {
    return parseInt(bin, 2);
}

export const isFirmwareVersionGreaterOrEqual = (version1, version2) => {
    const segments1 = version1.split('.').map(Number);
    const segments2 = version2.split('.').map(Number);

    for (let i = 0; i < segments1.length; i++) {
        if (segments1[i] > segments2[i]) {
            return true;
        } else if (segments1[i] < segments2[i]) {
            return false;
        }
    }

    return true;
}